import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import Sidebar from "@/components/sidebar/Sidebar.vue";
import Header from "@/components/header/Header.vue";
import ContentSidebar from "@/components/right-sidebars/content-sidebar/ContentSidebar.vue";
import CreateSection from "@/components/right-sidebars/CreateSection.vue";
import FileSidebar from "@/components/right-sidebars/FileSB.vue";
import AttachFile from "@/components/popups/attachments/attach-file/AttachFile.vue";
import AddMetadata from "@/components/popups/AddMetadata.vue";
import AddProductImage from "@/components/popups/AddProductImage.vue";
import ToggleEditMode from "@/components/header/ToggleEditMode.vue";
import { useUIProductsStore } from "@/stores/ui-products.store";
import { useUIFilesStore } from "@/stores/ui-files.store";
import { useUIContentTemplatesStore } from "@/stores/ui-content-template.store";
import { useUIGeneralStore } from "@/stores/ui-general.store";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useUIContentStore } from "@/stores/ui-content.store";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const uiProductsStore = useUIProductsStore();
const uiFilesStore = useUIFilesStore();
const uiContentTemplatesStore = useUIContentTemplatesStore();
const uiGeneralStore = useUIGeneralStore();
const uiContentStore = useUIContentStore();
const route = useRoute();

const hasSubheader = [
  "product",
  "adaptive-learning-systems-list",
  "adaptive-learning-system",
  "progress",
  "productTasks",
  "planning",
  "mcq",
  "qti-preview",
  "qti-editor",
  "html-editor",
  "html-preview",
  "question-editor",
  "als-question-editor",
  "question-preview",
  "create-batch",
  "content-extractor"
];
const has2Subheaders = [
  "product-permissions",
  "feature-management",
  "content-templates",
  "assets",
  "content"
];
const hasSubHeader = computed<boolean>(() => {
  return hasSubheader.includes(route.name as string);
});
const has2SubHeaders = computed<boolean>(() => {
  return has2Subheaders.includes(route.name as string);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'main-layout',
      {
        'right-sidebar-padding': _unref(uiGeneralStore).isRightSidebarOpen,
        'left-sidebar-padding': _unref(uiGeneralStore).isSidebarOpen,
        'has-subheader': hasSubHeader.value,
        'has-2-subheaders': has2SubHeaders.value
      }
    ]),
    "data-testing": "main-container"
  }, [
    _createVNode(Header),
    _createVNode(Sidebar),
    _createVNode(_component_router_view),
    (_unref(uiFilesStore).isAttachFileModalOpen)
      ? (_openBlock(), _createBlock(AttachFile, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(uiContentTemplatesStore).isAddMetadataModalOpen)
      ? (_openBlock(), _createBlock(AddMetadata, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(uiProductsStore).isProductImageModalVisible)
      ? (_openBlock(), _createBlock(AddProductImage, { key: 2 }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "sidebar-slide" }, {
        default: _withCtx(() => [
          (_unref(uiContentStore).sectionToDisplay)
            ? (_openBlock(), _createBlock(ContentSidebar, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "sidebar-slide" }, {
        default: _withCtx(() => [
          (_unref(uiFilesStore).fileForDisplay)
            ? (_openBlock(), _createBlock(FileSidebar, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "sidebar-slide" }, {
        default: _withCtx(() => [
          (_unref(uiContentStore).newSectionDetails)
            ? (_openBlock(), _createBlock(CreateSection, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(ToggleEditMode)
    ]))
  ], 2))
}
}

})